import React from 'react';
import styled from 'styled-components';

const PrivacyKo: React.FC = () => {
  return (
    <>
      <Section>
        <Title>개인정보처리방침</Title>
        <Text>
          아키트레이브(Architrave) (이하 ‘회사’라 함)은 「개인정보 보호법」 제30조에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같은 개인정보 처리방침을 수립·공개합니다.
        </Text>
        <Text>
          본 방침은 2025년 8월 12일부터 적용됩니다.
        </Text>
      </Section>
      <Section>
        <SmallTitle>
          제1조 (개인정보 처리 목적)
        </SmallTitle>
        <Text>
          회사는 다음의 목적을 위해 개인정보를 처리합니다. 처리된 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며, 이용 목적이 변경되는 경우 사전 동의를 받습니다.
        </Text>
        <Text>
          <List2>
            <li>
              <Strong>회원가입 및 관리</Strong>
              <List>
                <li>회원 가입 의사 확인, 본인 식별·인증, 이메일 인증</li>
                <li>만 14세 이상 여부 확인 및 이용약관·개인정보 수집·이용 동의 절차 수행</li>
              </List>
            </li>
            <li>
              <Strong>서비스 제공 및 운영</Strong>
              <List>
                <li>로그인, 서비스 이용, 구독 결제 처리</li>
                <li>서비스 성능 개선 및 향후 기능 기획을 위한 분석</li>
              </List>
            </li>
            <li>
              <Strong>고지사항 전달</Strong>
              <List>
                <li>서비스 변경, 약관 개정, 보안 관련 공지 등</li>
              </List>
            </li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제2조 (처리하는 개인정보 항목)
        </SmallTitle>
        <Text>
          - 필수 수집 항목: 이메일 주소, 비밀번호, 사용자 이름(닉네임) <br />
          - 자동 수집 항목: IP 주소, 브라우저 정보, 접속 일시, 서비스 이용 기록 <br />
          - 기타: 이메일 인증을 위한 인증 코드
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제3조 (개인정보 수집 방법)
        </SmallTitle>
        <Text>
          - 회원가입 시 이용자가 직접 입력한 정보 <br />
          - 이메일 인증 절차 중 생성되는 정보 <br />
          - 서비스 이용 과정에서 자동으로 생성되는 정보
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제4조 (개인정보 보유 및 이용 기간)
        </SmallTitle>
        <Text>
          회사는 수집한 개인정보를 수집·이용 목적 달성 시 또는 이용자의 회원 탈퇴 요청 시 지체 없이 파기합니다. 단, 관련 법령에 따라 아래 정보는 일정 기간 보관됩니다.
        </Text>
        <Table>
          <thead>
            <tr>
              <th>보존 항목</th>
              <th>관련 법령</th>
              <th>보존 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>표시·광고에 관한 기록</td>
              <td>전자상거래법 시행령 제6조</td>
              <td>6개월</td>
            </tr>
            <tr>
              <td>계약 또는 청약철회 등에 관한 기록</td>
              <td>전자상거래법 제6조</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>대금결제 및 재화 등의 공급에 관한 기록</td>
              <td>전자상거래법 제6조</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>소비자 불만 또는 분쟁처리에 관한 기록</td>
              <td>전자상거래법 제6조</td>
              <td>3년</td>
            </tr>
            <tr>
              <td>전자금융거래 기록</td>
              <td>전자금융거래법 제22조</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>접속 로그 등 통신사실 확인자료</td>
              <td>통신비밀보호법 제15조</td>
              <td>3개월</td>
            </tr>
          </tbody>
        </Table>
      </Section>

      <Section>
        <SmallTitle>
          제5조 (개인정보 제3자 제공)
        </SmallTitle>
        <Text>
          회사는 개인정보를 제3자에게 제공하지 않습니다. <br />
          단, Stripe를 통한 결제 처리는 회사가 위탁한 수탁자에 의해 처리되며, 제3자 제공에는 해당하지 않습니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제6조 (개인정보 처리 위탁)
        </SmallTitle>
        <Table>
          <thead>
            <tr>
              <th>수탁자</th>
              <th>위탁 업무</th>
              <th>보유 및 이용 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Stripe, Inc. (Polar.sh 포함)</td>
              <td>결제 처리, 정산, 과금 관련 고객 식별 및 거래 정보 처리</td>
              <td>회원 탈퇴 또는 위탁 계약 종료 시까지</td>
            </tr>
            <tr>
              <td>Amazon Web Services, Inc. 및 Amazon Web Services Korea LLC</td>
              <td>클라우드 인프라 제공 및 운영(서버·DB·스토리지·백업/복구·모니터링·보안) 및 콘텐츠 전송 네트워크(CDN, Amazon CloudFront) 운영·보안/성능 로그 처리</td>
              <td>회원 탈퇴 또는 위탁 계약 종료 시까지</td>
            </tr>
          </tbody>
        </Table>
      </Section>

      <Section>
        <SmallTitle>제7조 (개인정보 국외 이전)</SmallTitle>
        <Text>
          <List2>
            <li>
              <Strong>Stripe (미국 소재)</Strong>
              <List>
                <li><Strong>이전 대상:</Strong> Stripe, Inc. (미국 소재)</li>
                <li><Strong>이전 항목:</Strong> 이메일 주소 및 결제 관련 식별 정보</li>
                <li><Strong>이전 시점:</Strong> 사용자가 결제를 요청하는 경우</li>
                <li><Strong>이전 방법:</Strong> 네트워크를 통한 자동 전송</li>
                <li><Strong>보유 및 이용 기간:</Strong> 목적 달성 또는 회원 탈퇴 시까지</li>
                <li><Strong>국외 이전 거부 방법 및 영향:</Strong> 이용자는 다음 연락처 (architrave2025@gmail.com)를 통해 국외 이전에 대한 동의를 거부할 수 있습니다.
                  단, 결제 기능 제공이 불가능해져 서비스 이용에 제한이 발생할 수 있습니다. </li>
                <li>
                  Stripe 개인정보 처리방침: <Link href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">https://stripe.com/privacy</Link>
                </li>
              </List>
            </li>
            <li>
              <Strong>Amazon Web Services (전 세계 콘텐츠 전송망 운영)</Strong>
              <List>
                <li><Strong>이전 대상:</Strong> Amazon Web Services, Inc. (글로벌 엣지 로케이션 운영)</li>
                <li><Strong>이전 항목:</Strong> IP 주소, 요청 메타데이터(예: 브라우저 유형, OS, 접근 로그), 계정 식별 정보(해당하는 경우)</li>
                <li><Strong>이전 시점:</Strong> 사용자가 서비스를 이용하거나 콘텐츠에 접근하는 경우</li>
                <li><Strong>이전 방법:</Strong> 네트워크를 통한 자동 전송</li>
                <li><Strong>보유 및 이용 기간:</Strong> 목적 달성 또는 회원 탈퇴 시까지</li>
                <li><Strong>국외 이전 거부 방법 및 영향:</Strong> 콘텐츠 전송 네트워크(CDN)는 서비스 성능 및 보안을 위해 필수적으로 사용되므로, 별도로 거부할 수 없습니다. 서비스 이용을 중단하는 경우에만 국외 이전이 중지됩니다.</li>
                <li>
                  AWS 개인정보 처리방침: <Link href="https://aws.amazon.com/privacy" target="_blank" rel="noopener noreferrer">https://aws.amazon.com/privacy</Link>
                </li>
              </List>
            </li>
          </List2>
        </Text >
      </Section >

      <Section>
        <SmallTitle>
          제8조 (정보주체 권리 및 행사방법)
        </SmallTitle>
        <Text>
          이용자는 언제든지 다음의 권리를 행사할 수 있습니다.
        </Text>
        <Text>
          <List2>
            <li>개인정보 열람 요구</li>
            <li>정정 및 삭제 요구</li>
            <li>처리 정지 요구</li>
          </List2>
        </Text>
        <Text>
          요청은 이메일(architrave2025@gmail.com)을 통해 접수하실 수 있습니다. <br />
          회원가입 시 동의한 항목(만 14세 이상, 이용약관 및 수집 동의 등)은 언제든지 열람 및 철회 가능합니다.
        </Text>
      </Section >
      <Section>
        <SmallTitle>
          제9조 (개인정보 파기 절차 및 방법)
        </SmallTitle>
        <Text>
          - 전자적 파일: 복구 불가능한 기술적 방법으로 삭제 <br />
          - 출력물 등: 분쇄기로 파쇄 또는 소각
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제10조 (개인정보 자동 수집 장치의 설치 및 거부)
        </SmallTitle>
        <Text>
          회사는 서비스 운영을 위해 쿠키 등을 사용할 수 있습니다. <br />
          이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제11조 (개인정보 보호책임자)
        </SmallTitle>
        <Text>
          - 성명: 김영동 <br />
          - 직책: 대표 <br />
          - 전화번호: 010-5049-5056 <br />
          - 이메일: architrave2025@gmail.com <br />
          - 담당부서: 해당 없음 (1인 사업자로 대표가 직접 관리)
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제12조 (개인정보처리방침 변경)
        </SmallTitle>
        <Text>
          법령, 정책 또는 서비스 변경 시 사전 공지하며, <br />
          중대한 변경이 있을 경우 최소 30일 전부터 고지합니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제13조 (만 14세 미만 아동의 가입 제한)
        </SmallTitle>
        <Text>
          회사는 만 14세 미만 아동의 개인정보를 수집하지 않으며, <br />
          회원가입 시 "만 14세 이상임을 확인합니다" 항목에 대한 명시적 동의를 받습니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제14조 (개인정보 보호를 위한 기술적·관리적 대책)
        </SmallTitle>
        <Text>
          회사는 개인정보의 안전한 처리를 위하여 다음과 같은 기술적·관리적 보호 대책을 시행하고 있습니다.
        </Text>
        <Text>
          - 접근 권한의 최소화 <br />
          - 비밀번호의 암호화 저장 및 관리 <br />
          - 정기적인 백업 및 보안 업데이트 <br />
          - 해킹 및 악성코드 방지를 위한 보안 솔루션 적용 <br />
          - 개인정보 유출 또는 침해 사고 발생 시 지체 없는 통지 및 관계 기관 신고
        </Text>
      </Section>

      <Section>
        <SmallTitle>
          제15조 (권익침해에 대한 구제방법)
        </SmallTitle>
        <Text>
          정보주체는 아래 기관에 개인정보 침해에 대한 상담 또는 분쟁조정을 신청할 수 있습니다.
        </Text>
        <Text>
          - 개인정보분쟁조정위원회: <Link href="https://www.kopico.go.kr" target="_blank" rel="noopener noreferrer">https://www.kopico.go.kr</Link> / ☎ 1833-6972 <br />
          - 개인정보침해신고센터: <Link href="https://privacy.kisa.or.kr" target="_blank" rel="noopener noreferrer">https://privacy.kisa.or.kr</Link> / ☎ 118 <br />
          - 대검찰청 사이버수사과: <Link href="https://www.spo.go.kr" target="_blank" rel="noopener noreferrer">https://www.spo.go.kr</Link> / ☎ 1301 <br />
          - 경찰청 사이버수사국: <Link href="https://ecrm.cyber.go.kr" target="_blank" rel="noopener noreferrer">https://ecrm.cyber.go.kr</Link>
        </Text>
        <Text>
          또한 「개인정보 보호법」 제35조~제37조에 따른 권리 행사가 거절된 경우, <br />
          행정심판법에 따라 <Link href="https://www.simpan.go.kr" target="_blank" rel="noopener noreferrer">중앙행정심판위원회</Link>를 통해 구제 신청을 할 수 있습니다.
        </Text>
      </Section>
      <Text>
        본 방침은 2025년 8월 12일부터 적용됩니다.
      </Text>
    </>
  );
};

export default PrivacyKo;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_01};
  ${({ theme }) => theme.typography.Body_02_1};
  margin-bottom: 16px;
  `;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
  `;

const SmallTitle = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_01};
  ${({ theme }) => theme.typography.Body_03_1};
  margin-bottom: 4px;
  `;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
  line-height: 1.4;
  `;

const Link = styled.a`
  color: ${({ theme }) => theme.colors.color_Gray_02};
  text-decoration: underline;
  `;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  border: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  th, td {
    border: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  padding: 4px 4px;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
  text-align: left;
  line-height: 1.4;
  }
  th {
    background: ${({ theme }) => theme.colors.color_Gray_07};
  color: ${({ theme }) => theme.colors.color_Gray_01};
  }
        `;

const List = styled.ul`
        list-style: disc;
        padding-left: 14px;
      `;

const List2 = styled.ol`
        list-style: decimal;
        padding-left: 14px;
        li {
          margin-bottom: 4px;
        }
      `;

const Strong = styled.strong`
        font-weight: ${props => props.theme.fontWeight.medium};
      `;